import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { submitDelegateEnquiry } from '../../api/enquiryApi';

const SponsorshipModal = ({ isOpen, onClose, tierId: preselectedTierId }) => {
  const [formData, setFormData] = useState({
    organization: '',
    Name: '',
    designation: '',
    tierId: '',
    email: '',
    phone: '',
    message: '',
    Opertunity:''
  });

  const [errors, setErrors] = useState({});
  const [tierOptions, setTierOptions] = useState([
      {value:1, label:"VIP Pass (CXO's)"},
      {value:2, label:"Defence Personnel Delegate"},
      {value:3, label:"Industry Professional Delegate"},
      {value:4, label:"Institution Professional Delegate"},
      {value:5, label:"HEI Student Delegate"},
      {value:6, label:"Youth Delegate"},
      {value:7, label:"School Student Delegate"},
      {value:8, label:"VIP Pass(CORPORATES / DEFENCE / PSU's / STARTUP's)"},
      {value:9, label:"CORPORATES / DEFENCE / PSU's / STARTUP's"},
      {value:10, label:"INSTITUTIONS"}
  ]);
  const [loadingTiers, setLoadingTiers] = useState(false);



  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'tierId') {
      const selectedTier = tierOptions.find(t => t.value === parseInt(value));
      setFormData(prev => ({
        ...prev,
        tierId: parseInt(value, 10) || '',
        Opertunity:selectedTier.label
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    console.log(formData)
    if (!formData.Name.trim()) newErrors.Name = 'Name is required.';
    if (!formData.organization.trim()) newErrors.organization = 'Organization is required.';
    // if (!formData.contactPerson.trim()) newErrors.contactPerson = 'Contact person is required.';
    if (!formData.designation.trim()) newErrors.designation = 'Designation is required.';
    //if (!formData.tierId) newErrors.tierId = 'Opertunity selection is required.';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email format.';
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone is required.';
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = 'Invalid phone number.';
    }

    return newErrors;
  };

  const transformPayload = (data) => ({
    FullName: data.Name,
    Organization: data.organization,
    Role: data.designation,
    Email: data.email,
    Phone: data.phone,
    Opertunity: data.Opertunity,
    Message: data.message
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = transformPayload(formData);
      const result = await submitDelegateEnquiry(payload);
      if (result.success) {
        toast.success('Thank you! Your enquiry has been submitted.');
        onClose();
      } else {
        toast.error('Submission failed. Please try again.');
      }
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
  <div
    style={{
      background: "linear-gradient(93.84deg, #EA5133 0%, #5744B1 100%)",
       // match inner radius
      padding: "2px", // thin gradient border
    }}
    className="w-fit relative rounded-2xl"
  >
 
      <div className="bg-darkbg text-white p-5 md:p-8 rounded-2xl w-full max-w-3xl font-inter border border-white/10 shadow-xl overflow-y-auto max-h-[95vh] animate-fade-in">
        
        <div className="flex justify-between items-center mb-6 flex-wrap gap-y-2">
          <h2 className="text-xl md:text-2xl font-semibold text-lavender">Delegate Enquiry</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-2xl font-bold"
            aria-label="Close modal"
          >
            &times;
          </button>
        </div>

        <p className="text-gray-400 text-sm md:text-base mb-6">
         Fill Out the Form to Register Interest as a Distinguished Delegate.
        </p>

        <form onSubmit={handleSubmit} autocomplete="off">
          <div key={'Name'}>
                <label className="text-sm font-medium">Name</label>
                <input
                  name={"Name"}
                  type={'text'}
                  value={formData['Name']}
                  onChange={handleChange}
                  placeholder={'Your Name'}
                  className="w-full px-4 py-3 mt-1 rounded-full bg-midbg text-white focus:outline-none"
                />
                {errors['Name'] && <p className="text-red-500 text-sm mt-1">{errors['Name']}</p>}
              </div>
         <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 md:gap-y-6 gap-x-4">
          

            {[
              { label: 'Email', name: 'email', type: 'email', placeholder: 'contact@org.com' },
              { label: 'Phone', name: 'phone', type: 'tel', placeholder: 'XXXXXXXXXX' },
              { label: 'Organization', name: 'organization', type: 'text', placeholder: 'Organization' },
              { label: 'Designation', name: 'designation', type: 'text', placeholder: 'Your designation' },
              
            ].map(({ label, name, type, placeholder }) => (
              <div key={name}>
                <label className="text-sm font-medium">{label}</label>
                <input
                  name={name}
                  type={type}
                  value={formData[name]}
                  onChange={handleChange}
                  placeholder={placeholder}
                  className="w-full px-4 py-3 mt-1 rounded-full bg-midbg text-white focus:outline-none"
                />
                {errors[name] && <p className="text-red-500 text-sm mt-1">{errors[name]}</p>}
              </div>
            ))}

            {/* <div>
              <label className="text-sm font-medium">Delegate Opportunities</label>
              {loadingTiers ? (
                <div className="text-gray-400 mt-2">Loading Opportunities...</div>
              ) : (
                <select
                  name="tierId"
                  value={formData.tierId}
                  onChange={handleChange}
                  className="w-full px-4 py-3 mt-1 rounded-full bg-midbg text-white focus:outline-none"
                >
                  <option value="">Select Opportunity</option>
                  {tierOptions.map(tier => (
                    <option key={tier.value} value={tier.value}>
                      {tier.label}
                    </option>
                  ))}
                </select>
              )}
              {errors.tierId && <p className="text-red-500 text-sm mt-1">{errors.tierId}</p>}
            </div> */}
          </div>

          <div className="mt-6">
            <label className="text-sm font-medium">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your message..."
              className="w-full px-4 py-3 mt-1 rounded-xl bg-midbg text-white focus:outline-none resize-y min-h-[100px]"
            />
          </div>

          <div className="mt-8 text-center">
            <button
              type="submit"
              className="bg-[linear-gradient(90deg,#EA5133,#5744B1)] text-white font-semibold px-8 py-3 rounded-full hover:opacity-90 transition-opacity w-full md:w-auto"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      </div>
    </div>
  );
};

export default SponsorshipModal;
